// extracted by mini-css-extract-plugin
module.exports = {"zone":"styles_zone__e_M9W"};